import { Link, useParams } from 'react-router'
import Table from '../Components/AdminTable.js'
import { useEffect, useState } from 'react'
import { call } from '../Methods.js'
import { use } from '../Helpers.js'
import FormModal from '../Components/FormModal.js'

function Requests () {
  const pageName = 'requests'
  const pageTitle = 'Müraciətlər'
  document.title = `${pageTitle} | ${process.env.REACT_APP_NAME}`
  const [updateTable, setUpdateTable] = useState(false)

  useEffect(() => {
    if (updateTable) {
      setUpdateTable(false)
    }
  }, [updateTable])

  const tableSettings = {
    name: '',
    label: '',
    filters: true,
    pagination: true,
    actions: {
      get: async (params = {}) => {
        const requests = await call.forLoggedUser.request.getRequests(params)
        if (requests.success) {
          return requests.data
        }
        return []
      }
    },
    columns: [
      {
        title: '#',
        property: 'rowNumber',
        style: { width: '30px' },
        filter: {
          enabled: false
        }
      },
      {
        title: 'Status',
        property: ['statusId', 'statusName'],
        type:'status-label',
        style: { width: '15%' },
        filter: {
          enabled: true,
          type: 'select',
          name: 'statusId',
          dataSource: async () => {
            const source = await call.forLoggedUser.status.getStatuses({
              type: 'request'
            })
            let data = source.data?.map(d => {
              return { value: d.id, text: d.description }
            })
            return data
          }
        },
        mutate: values => {
          return values[1]
        }
      },
      {
        title: 'Filial',
        property: ['branchCode','branchName'],
        mutate:(values)=><span title={values[1]}>{values[0]}</span>,
        filter: {
          enabled: true,
          type: 'select',
          name: 'branchId',
          dataSource: async () => {
            const source = await call.forLoggedUser.branch.getBranches({})
            let data = source.data.map(d => {
              return { value: d.id, text: d.name }
            })
            return data
          }
        },
        style: { width: '10%' },
      },
      {
        title: 'Müraciətçi',
        property: 'requesterFullName',
        style: { width: '30%' },
        filter: {
          enabled: true,
          type: 'text',
          name: 'requesterFullName'
        }
      },
      {
        title: 'Tarix',
        property: 'requestDate',
        style: { width: '10%' },
        filter: {
          enabled: true,
          type: 'month',
          name: 'requestMonth'
        },
        mutate: value => {
          return use.convertDatetimeToShortDate(value)
        }
      },
      {
        title: 'Əlaqə',
        property: ['phone1', 'phone2'],
        style: { width: '15%' },
        filter: {
          enabled: true,
          type: 'tel',
          name: 'phone'
        },
        mutate: values => {
          return (
            <>
              <p>{values[0]}</p>
              <p>{values[1]}</p>
            </>
          )
        }
      },
      {
        title: 'İşt. / Nam.',
        description: 'İştirakçılar / Namizədlər',
        property: ['studentCount','candidateCount'],
        style: { width: '10%' },
        filter: {
          enabled: true,
          type: 'select',
          data:[
            {value:0,text:'Heç qoşulmayıb'},
            {value:1,text:'Qismən qoşulub'},
            {value:2,text:'Tam qoşulub'},
          ],
          name: 'requestResults'
        },
        mutate:(values)=>`${values[0]} / ${values[1]}`
      },
      {
        title: 'Əməliyyat',
        property: 'id',
        type: 'actions-list',
        operations:(value)=>[
          {
            type:'link',
            name:'Edit',
            title:'Düzəliş',
            link:`${value}`,
            iconType:'path',
            icon:'/Images/Icons/edit.png',
            disablingConditions:[],
          },
          {
            type:'command',
            name:'delete',
            title:'Qeydi sil',
            parameters:`{"id":${value},"entity":"request"}`,
            iconType:'path',
            icon:'/Images/Icons/delete.png',
            disablingConditions:[]
          }
        ],
        style: {width:'10%',minWidth: '50px'}
      }
    ],
    addNew: {
      enabled: true,
      url: `/${pageName}/add`,
      title: '+ Əlavə et'
    }
  }

  const formSettings = [
    {
      name: 'request',
      id: '',
      label: 'Müraciət',
      isStandAlone: true,
      isMain: true,
      actions: {
        get: id => call.forLoggedUser.request.getRequestById({ id: id }),
        add: call.forLoggedUser.request.addRequest,
        edit: call.forLoggedUser.request.updateRequest
      },
      formLists: {
        Branches: async () => {
          const source = await call.forLoggedUser.branch.getBranches({})
          return source.data.map(d => {
            return { value: d.id, text: d.name }
          })
        },
        RequestTypes: async () => {
          const source = await call.forLoggedUser.listOption.getListOptions({
            listName: 'RequestType'
          })
          return source.data.map(d => {
            return { value: d.value, text: d.text, selected: false }
          })
        },
        Statuses: async () => {
          const source = await call.forLoggedUser.status.getStatuses({
            type: 'request'
          })
          return source.data.map(d => {
            return { value: d.id, text: d.description }
          })
        }
      },
      fields: [
        { type: 'hidden', fieldName: 'id', label: '' },
        {
          label: 'Müraciət tarixi',
          type: 'date',
          fieldName: 'requestDate',
          validationRules: ['required'],
          col: { sm: 3 },
          defaultValue: new Date().toLocaleDateString('az-AZ'),
          mutate: value => {
            return value!=null ? new Date(value).toLocaleDateString('az-AZ'): null
          }
        },
        {
          label: 'Filial',
          type: 'select',
          fieldName: 'branchId',
          col: { sm: 3 },
          data: 'Branches'
        },
        {
          label: 'Müraciət edən şəxs',
          type: 'text',
          fieldName: 'requesterFullName',
          validationRules: ['required'],
          col: { sm: 3 },
          eventHandlers: [
            {
              type: 'change',
              handler: e => console.log(e.target.value)
            }
          ]
        },
        {
          label: 'Müraciət növü',
          type: 'select',
          fieldName: 'requestTypeId',
          col: { sm: 3 },
          data: 'RequestTypes'
        },
        {
          label: 'Sosial şəbəkə hesabı',
          type: 'text',
          fieldName: 'socialNetworkAccount',
          col: { sm: 3 }
        },
        {
          label: 'Telefon 1',
          type: 'text',
          fieldName: 'phone1',
          validationRules: ['required'],
          col: { sm: 3 }
        },
        {
          label: 'Telefon 2 (Whatsapp)',
          type: 'text',
          fieldName: 'phone2',
          col: { sm: 3 }
        },
        {
          label: 'Status',
          type: 'select',
          fieldName: 'statusId',
          defaultValue: 0,
          col: { sm: 3 },
          data: 'Statuses'
        },
        {
          label: 'Əlavə qeydlər',
          type: 'textarea',
          fieldName: 'notes',
          col: { sm: 6 }
        },
        { type: 'submit', label: 'Təsdiq', col: { sm: 12 } }
      ]
    },
    {
      name: 'candidates',
      id: '',
      label: 'Namizədlər',
      isStandAlone: false,
      isMain: false,
      actions: {
        get: id =>
          call.forLoggedUser.request.getCandidateList({ requestId: id }),
        edit: call.forLoggedUser.request.editCandidateList
      },
      formLists: {
        Statuses: async () => {
          const source = await call.forLoggedUser.status.getStatuses({
            type: 'candidate'
          })
          let data = source.data.map(d => {
            return { value: d.id, text: d.description }
          })
          return data
        },
        Courses: async () => {
          const source = await call.forLoggedUser.course.getCourses({})
          let data = source.data.map(d => {
            return { value: d.id, text: d.name, selected: false }
          })
          return data
        },
        Genders: async () => {
          const source = await call.forLoggedUser.listOption.getListOptions({
            listName: 'Gender'
          })
          let data = source.data.map(d => {
            return { value: d.value, text: d.text }
          })
          return data
        }
      },
      fields: [
        { type: 'hidden', fieldName: 'requestId', label: '' },
        {
          label: 'Müraciətçinin adı',
          fieldName: 'requesterFullName',
          type: 'readonly-text',
          col: { sm: 6 }
        },
        {
          label: 'Müraciət tarixi',
          fieldName: 'requestDate',
          type: 'readonly-text',
          mutate: value => {
            return use.convertDatetimeToShortDate(value)
          },
          col: { sm: 3 }
        },
        {
          label: 'Namizədlər',
          type: 'input-group-row',
          fieldName: 'candidates',
          defaultValue: [],
          addRowPermission: true,
          multipleRows: true,
          removeRowPermission: true,
          rowStyleRules: [
            {
              fieldName: 'id',
              getStyleRule: value =>
                value < 0 ? { backgroundColor: '#ffd4d4' } : {}
            }
          ],
          rowFields: [
            {
              label: '',
              type: 'hidden',
              fieldName: 'id'
            },
            {
              label: '',
              type: 'hidden',
              fieldName: 'requestId'
            },
            {
              label: '',
              type: 'hidden',
              fieldName: 'studentId'
            },
            {
              label: 'Status',
              type: 'select',
              fieldName: 'statusId',
              disabled: true,
              defaultValue: 0,
              columnWidth: '15%',
              data: 'Statuses'
            },
            {
              label: 'Təlim',
              type: 'select',
              fieldName: 'requestCourseId',
              validationRules: ['required'],
              columnWidth: '17%',
              data: 'Courses'
            },
            {
              label: 'Adı',
              type: 'text',
              fieldName: 'name',
              columnWidth: '10%',
              validationRules: ['required']
            },
            {
              label: 'Soyadı',
              type: 'text',
              fieldName: 'surname',
              columnWidth: '10%',
              col: { sm: 1 }
            },
            {
              label: 'Doğum tarixi',
              type: 'date',
              fieldName: 'birthDate',
              columnWidth: '10%',
              mutate: value => {
                return new Date(value).toLocaleDateString('az-AZ')
              }
            },
            {
              label: 'Cinsi',
              type: 'select',
              fieldName: 'gender',
              columnWidth: '7%',
              data: 'Genders'
            },
            {
              label: 'Sınaq Dərsi',
              type: 'checkbox',
              fieldName: 'trialLesson',
              columnWidth: '9%',
              mutate: value => {
                return value == 1
              }
            },
            {
              label: 'Depozit',
              type: 'number',
              fieldName: 'depositAmount',
              defaultValue:'0',
              columnWidth: '7%',
              defaultValue:0,
              disabled: true
            },
            {
              label: 'Qeydlər',
              type: 'textarea',
              columnWidth: '15%',
              fieldName: 'notes'
            },
            {
              label: 'Əməliyyatlar',
              type: 'operations',
              fieldName: 'id',
              columnWidth: '20%',
              operations: [
                {
                  type:'command',
                  name:'addDeposit',
                  title:'Depozit',
                  parameters:['id'],
                  iconStyle:{fontSize: '11px'},
                  icon:'₼',
                  disablingConditions:[
                    {
                      fieldName:'id',
                      checkCondition:value=>isNaN(value)
                    }
                  ]
                },
                {
                  type:'command',
                  name: 'addToGroup',
                  title:'Qrupa əlavə et',
                  iconType:'path',
                  icon:'/Images/Icons/menu-icons/group.svg',
                  parameters: ['id'],
                  disablingConditions: [
                    {
                      fieldName: 'statusId',
                      checkCondition: value =>
                        value!=0
                    },
                    
                    {
                      fieldName: 'id',
                      checkCondition: value =>
                      [undefined, null, ''].includes(value)
                    },
                  ]
                },
                {
                  type: 'delete',
                  title: 'Sil',
                  iconType:'path',
                  icon:'/Images/Icons/delete.png',
                  iconStyle:{filter:'invert(1)'},
                  disablingConditions: [
                    {
                      fieldName: 'studentGroupId',
                      description:'',
                      checkCondition: value =>
                      ![undefined, null, ''].includes(value)
                    },
                    {
                      fieldName: 'depositAmount',
                      description:'Balansı müsbət olan namizəd silinə bilməz. Əvvəlcə namizədin depozit balansını sıfırlayın.',
                      checkCondition: value => value > 0
                    }
                  ]
                }
              ]
            }
          ]
        },
        { type: 'submit', label: 'Yadda saxla', col: { sm: 12 } }
      ]
    },
    {
      name: 'students',
      id: '',
      label: 'İştirakçılar',
      isStandAlone: false,
      isMain: false,
      actions: {
        get: id => call.forLoggedUser.request.getStudentList({ requestId: id }),
        edit: call.forLoggedUser.request.editStudentList
      },
      formLists: {
        Statuses: async () => {
          const source = await call.forLoggedUser.status.getStatuses({
            type: 'studentGroup'
          })
          let data = source.data.map(d => {
            return { value: d.id, text: d.description }
          })
          return data
        }
      },
      fields: [
        { type: 'hidden', fieldName: 'requestId', label: '' },
        {
          label: 'Müraciətçinin adı',
          fieldName: 'requesterFullName',
          type: 'readonly-text',
          col: { sm: 6 }
        },
        {
          label: 'Müraciət tarixi',
          fieldName: 'requestDate',
          type: 'readonly-text',
          col: { sm: 6 },
          mutate: value => {
            return use.convertDatetimeToShortDate(value)
          }
        },
        {
          label: 'İştirakçılar',
          type: 'input-group-row',
          fieldName: 'students',
          defaultValue: [],
          addRowPermission: false,
          multipleRows: true,
          removeRowPermission: true,
          rowStyleRules: [
            {
              fieldName: 'id',
              getStyleRule: value =>
                value < 0 ? { backgroundColor: '#ffd4d4' } : {}
            }
          ],
          col: { sm: 12 },
          rowFields: [
            {
              label: '',
              type: 'hidden',
              fieldName: 'id'
            },
            {
              label: '',
              type: 'hidden',
              fieldName: 'studentId'
            },
            {
              label: 'Adı və soyadı',
              type: 'text',
              disabled: true,
              fieldName: 'name',
              columnWidth: '15%'
            },
            {
              label: 'Qrup',
              type: 'text',
              disabled: true,
              fieldName: 'groupName',
              columnWidth: '15%'
            },
            {
              label: 'Aylıq',
              type: 'number',
              fieldName: 'monthlyPayment',
              columnWidth: '10%'
            },
            {
              label: 'Ödənilib',
              type: 'number',
              fieldName: 'paidAmount',
              columnWidth: '10%',
              disabled: true
            },
            {
              label: 'Nəticə',
              type: 'number',
              disabled: true,
              fieldName: 'grade',
              columnWidth: '10%'
            },
            {
              label: 'Qeydlər',
              type: 'text',
              fieldName: 'notes',
              columnWidth: '20%'
            },
            {
              label: 'Status',
              type: 'select',
              fieldName: 'statusId',
              columnWidth: '20%',
              data: 'Statuses'
            },
            ,
            {
              label: 'Əməliyyatlar',
              type: 'operations',
              fieldName: 'id',
              columnWidth: '20%',
              operations: [
                // {
                //   type:'command',
                //   name: 'groupTransfer',
                //   title:'Qrupu dəyiş',
                //   iconType:'path',
                //   icon:'/Images/Icons/transfer.png',
                //   parameters: ['line:stidentId','line:name','global:groupId'],
                //   disablingConditions: [
                //     {
                //       fieldName: 'statusId',
                //       checkCondition: value=>![0,1].includes(value)
                //     }
                //   ]
                // },
                {
                  type: 'delete',
                  title: 'Sil',
                  iconType:'path',
                  icon:'/Images/Icons/delete.png',
                  iconStyle:{filter:'invert(1)'},
                  disablingConditions: [
                    {
                      fieldName: 'statusId',
                      checkCondition: value => value != 0
                    },
                    {
                      fieldName: 'paidAmount',
                      checkCondition: value => value > 0
                    }
                  ]
                }
              ]
            },
          ]
        },
        { type: 'submit', label: 'Yadda saxla', col: { sm: 12 } }
      ]
    }
  ]

  return (
    <div className='page'>
      <h1 className='page-title'>{pageTitle}</h1>
      {/* <h5 className='page-description'>Bu səhifə kursun təşkil etdiyi bütün təlimlərin göstərilməsi, əlavə olunması və düzəlişlərin aparılması üçündür.</h5> */}
      <Table tableSettings={tableSettings} updateTable={updateTable} />

      <FormModal
        moduleUrl={`/${pageName}`}
        formSettings={formSettings}
        onSubmit={() => setUpdateTable(true)}
      />
    </div>
  )
}

export default Requests
